import { Component } from '@angular/core';

@Component({
    selector: 'offline-error',
    templateUrl: './offline-error.html',
    styleUrls: [ './fullscreen-message.scss' ],
})
export class OfflineError {}
